module.exports = __webpack_public_path__ + "static/media/rose-gold-badge.4c101fe6.svg";